import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { DEMOGRAPHICS_ICON_LIST } from '../../constants';
import * as insight360Actions from '../../actions/insight360Actions';

class DemographicDetail extends Component {

  getImageIcon = imageKey => {
    const imageComponent = _.find(DEMOGRAPHICS_ICON_LIST, {
      demoName: imageKey,
    });
    if (imageComponent !== undefined) {
      return imageComponent.selectedIcon;
    }
    return undefined;
  }

  renderDeepDiveSlider = value => {
    const { personaIndex, demoDetail, displayDeepDiveSlider, selectedTab } = this.props;

    const deepDivePersonaObject = {
      personaIndex,
      category: demoDetail.name,
      section: 'Demographics',
      selectedTab,
    };
    displayDeepDiveSlider(value, deepDivePersonaObject);
  }

  render() {
    return (
      <div>
        {this.props.demoDetail !== undefined && (
          <div className="demographic-detail-grid" onClick={() => { this.renderDeepDiveSlider(true); }}>
            {this.getImageIcon(this.props.demoDetail.name) === undefined && (
              <div className="imageblock" />
            )}
            {this.getImageIcon(this.props.demoDetail.name) !== undefined && (
              <center>
                <img
                  className="i360-demo-img"
                  src={this.getImageIcon(this.props.demoDetail.name)}
                  alt={this.props.demoDetail.name}
                />
              </center>
            )}
            <div className="demo-labels">{this.props.demoDetail.name}</div>
            <div
              className="demo-data demo-single-label"
              title={
                this.props.demoDetail.data !== undefined
                  ? this.props.demoDetail.data.label
                  : 'N/A'
              }
            >
              {this.props.demoDetail.data !== undefined
                ? this.props.demoDetail.data.label
                : 'N/A'}
            </div>
            <div className="demo-metrics align-bottom">
              INDEX:&nbsp;&nbsp;
              {this.props.demoDetail.data !== undefined
                ? this.props.demoDetail.data.value.index
                : 'N/A'}{' '}
              | REACH:&nbsp;&nbsp;
              {this.props.demoDetail.data !== undefined
                ? this.props.demoDetail.data.value.pct
                : 'N/A'}{' '}
            </div>
          </div>
        )}
      </div>
    );
  }

}
DemographicDetail.propTypes = {
  displayDeepDiveSlider: PropTypes.func,
  personaIndex: PropTypes.number,
  demoDetail: PropTypes.shape({
    name: PropTypes.string,
    data: PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.shape({
        pct: PropTypes.string,
        index: PropTypes.number,
      })
    })
  }),
  selectedTab: PropTypes.string,
};

function mapDispatchToProps(dispatch) {
  const displayDeepDiveSlider = (value, deepDivePersonaObject) => {
    dispatch(insight360Actions.showDeepDivePopup(value, deepDivePersonaObject));
  };
  return {
    displayDeepDiveSlider,
  };
}

export default connect(
  null,
  mapDispatchToProps,
  null,
  { forwardRef: true },
)(DemographicDetail);
